import { Link } from "react-router-dom";
import { Globe2, Mail } from "lucide-react";
import { BrandHeader } from "./Login";

export default function AccessRestricted() {
  return (
    <div className="min-h-screen bg-[#F9FAFB] flex flex-col" data-testid="access-restricted-page">
      <div className="px-6 pt-8 sm:px-12 sm:pt-12">
        <BrandHeader />
      </div>

      <div className="flex-1 flex items-center justify-center px-6 pb-10">
        <div className="w-full max-w-lg text-center">
          <div className="mx-auto h-14 w-14 rounded-full bg-[#C9A84C]/15 text-[#C9A84C] flex items-center justify-center mb-6">
            <Globe2 className="h-7 w-7" strokeWidth={1.8} />
          </div>
          <div className="text-[11px] uppercase tracking-[0.3em] text-[#C9A84C] font-semibold mb-2">
            Access restricted
          </div>
          <h1 className="font-heading text-3xl sm:text-4xl font-bold text-[#1A2744] leading-tight">
            The Staff Portal is available in New&nbsp;Zealand only.
          </h1>
          <p className="mt-4 text-gray-500">
            It looks like you're signing in from outside New Zealand.
            The staff portal — timesheets, leave and clock-in — is limited to our
            café team on the ground. Please contact your manager if you believe
            this is a mistake.
          </p>

          <div className="mt-8 p-5 rounded-xl border border-[#C9A84C]/30 bg-[#C9A84C]/5 text-sm text-[#1A2744] text-left">
            <div className="flex items-start gap-2.5">
              <Mail className="h-4 w-4 mt-0.5 text-[#C9A84C]" strokeWidth={1.8} />
              <div>
                <div className="font-semibold">Need help?</div>
                <div className="text-xs text-[#1A2744]/70 mt-0.5">
                  Ask your café manager to unlock access for you, or reach out
                  via the shared team channel. Managers and owners can still
                  sign in from anywhere at
                  {" "}
                  <Link to="/admin/login" className="underline underline-offset-4 text-[#C9A84C] hover:text-[#1A2744]">
                    /admin/login
                  </Link>.
                </div>
              </div>
            </div>
          </div>

          <div className="mt-8 flex items-center justify-center gap-3">
            <Link
              to="/login"
              className="text-xs text-gray-500 hover:text-[#1A2744] underline underline-offset-4"
              data-testid="retry-login"
            >
              Try staff sign-in again
            </Link>
            <span className="text-gray-300">·</span>
            <Link
              to="/admin/login"
              className="text-xs text-gray-500 hover:text-[#1A2744] underline underline-offset-4"
              data-testid="manager-login-from-restricted"
            >
              Manager sign-in
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
}
